import React, { useState, useEffect } from "react";
import { createSubscriptionCheckoutSessionWithTrial } from "../../../audiblogsApi";
import { observer } from "mobx-react";
import mixpanel from "mixpanel-browser";
import loadingIcon from "../../../Assets/loading.gif";
import userStore from "../../../Stores/User";
import { loadStripe } from "@stripe/stripe-js";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "../../../firebase";
import queryString from "query-string";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

const FreeTrial = observer((props) => {
  const [sessionId, setSessionId] = useState(null);
  const { user, firebaseUser, idToken, creditsHd } = userStore;
  const params = queryString.parse(props.location.search);
  const voice = params.voice;
  const app = params.app || "";

  const uiConfig = {
    signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
    },
  };

  const redirectToCheckout = (sessionId) => {
    stripePromise.then((stripe) => {
      console.log(sessionId);
      stripe
        .redirectToCheckout({
          sessionId,
        })
        .then((handleResult) => {
          console.log("handle results");
          handleResult();
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };
  useEffect(() => {
    if (user) {
      // Get Stripe Checkout Session Id
      createSubscriptionCheckoutSessionWithTrial(
        true,
        idToken,
        `${app ? "/onboarding/HowToClip" : "/add"}`,
        "Unreal"
      )
        .then(function (data) {
          redirectToCheckout(data.data.sessionId);
        })
        .catch((e) => {
          console.log(e);
          // alert("Something went wrong. Please try again or contact us.");
        });
    }
  }, [user]);

  useEffect(() => {
    mixpanel.track(`Open Trial Page (Onboarding)`);
  }, []);

  return firebaseUser === null ? (
    <>
      <div className="center-static" style={{ maxWidth: "800px" }}>
        <h1 className="headline">
          Cool, let's create an account
        </h1>
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
        />

      </div>
    </>
  ) : (
    <>
      <div className="center">
        <h1 className="headline">Redirecting to Stripe...</h1>
        <h1 className="subheadline">This should only take a few seconds</h1>
        <img src={loadingIcon} style={{height: '50px'}} />
      </div>
    </>
  );
});

export default FreeTrial;
